import { invitation } from '@/constants/invitation'

const CRLF = String.fromCharCode(13, 10)
const ICS_LINE_LENGTH = 60

const { honoree, age, startsAt, endsAt, venue, dressCode } = invitation

export const eventTitle = `Les ${age} ans de ${honoree}`

export const eventLocation = `${venue.name}, ${venue.street}, ${venue.postalCode} ${venue.city}`

const eventDetails = `Soirée d’anniversaire de ${honoree} : cocktails, buffet, gâteau et piste de danse. Dress code : ${dressCode.title.toLowerCase()}.`

// 2026-12-12T19:30:00+01:00 becomes 20261212T183000Z
const toUtcStamp = (date: Date): string => date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')

export const googleCalendarUrl = (): string => {
    const params = new URLSearchParams({
        action: 'TEMPLATE',
        text: eventTitle,
        dates: `${toUtcStamp(new Date(startsAt))}/${toUtcStamp(new Date(endsAt))}`,
        details: eventDetails,
        location: eventLocation
    })

    return `https://calendar.google.com/calendar/render?${params.toString()}`
}

export const googleMapsUrl = (): string => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(eventLocation)}`

const escapeText = (value: string): string => value.replace(/\s+/g, ' ').replace(/([\\;,])/g, '\\$1')

const foldLine = (line: string): string => {
    if (line.length <= ICS_LINE_LENGTH) return line

    const parts = [line.slice(0, ICS_LINE_LENGTH)]

    for (let index = ICS_LINE_LENGTH; index < line.length; index += ICS_LINE_LENGTH - 1) {
        parts.push(` ${line.slice(index, index + ICS_LINE_LENGTH - 1)}`)
    }

    return parts.join(CRLF)
}

export const calendarFileName = 'invitation-anniversaire.ics'

export const buildIcs = (now: Date): string => {
    const lines = [
        'BEGIN:VCALENDAR',
        'VERSION:2.0',
        'PRODID:-//Invitation anniversaire//FR',
        'CALSCALE:GREGORIAN',
        'METHOD:PUBLISH',
        'BEGIN:VEVENT',
        `UID:anniversaire-${toUtcStamp(new Date(startsAt))}@invitation`,
        `DTSTAMP:${toUtcStamp(now)}`,
        `DTSTART:${toUtcStamp(new Date(startsAt))}`,
        `DTEND:${toUtcStamp(new Date(endsAt))}`,
        `SUMMARY:${escapeText(eventTitle)}`,
        `DESCRIPTION:${escapeText(eventDetails)}`,
        `LOCATION:${escapeText(eventLocation)}`,
        'BEGIN:VALARM',
        'TRIGGER:-P1D',
        'ACTION:DISPLAY',
        `DESCRIPTION:${escapeText(`Demain : ${eventTitle}`)}`,
        'END:VALARM',
        'END:VEVENT',
        'END:VCALENDAR'
    ]

    return lines.map(foldLine).join(CRLF) + CRLF
}
